/**
 * apply a field change to local form state (including optimistic
 * updates before `postCollect` returns)
 */
import { collectFieldType } from '_shared/constants/collectionTypes';

export function applyCollectFieldToFormData(prev, field, value) {
  const next = { ...prev };
  next[field] = value;
  if (field === collectFieldType.LAST_SHOT_TYPE && value === 'serve') {
    next.situation = 'serving';
  } else if (field === collectFieldType.LAST_SHOT_TYPE && value === 'return') {
    next.situation = 'returning';
  }
  return next;
}

export function buildPostCollectVariables(
  formData,
  rallyLengthCount,
  matchId,
  pointJoinKey,
  set,
  game,
  point,
  fieldName,
  value
) {
  let resolvedValue = value;
  if (fieldName === collectFieldType.RALLY_LENGTH) {
    resolvedValue = rallyLengthCount;
  } else if (fieldName === collectFieldType.OUT_TYPE && formData?.out_type === value) {
    resolvedValue = '';
  }
  return {
    matchId,
    pointJoinKey,
    set,
    game,
    point,
    fieldName,
    value: resolvedValue
  };
}
